import * as React from 'react';
import { Row, Col } from 'antd';

import { TaxonomyTagsEditorController } from 'src/app/general/taxonomies/parts/taxonomy-tags-editor.controller';

interface Props {
	fieldsTaxonomy: TaxonomicField[];
	model: Search;
	setBusy: (isBusy: boolean) => void;
}

export const SearchTaxonomies: React.SFC<Props> = (props: Props): JSX.Element => (
	<Row gutter={16}>
		{
			props.fieldsTaxonomy.map(m => (
				<Col xs={12} key={m.jsonSchemaPropertyName}>
					<TaxonomyTagsEditorController
						multi
						label={m.displayName}
						taxonomyDefinitionName={m.jsonSchemaDefinitionName}
						value={(props.model.taxonomies.find(t => t.jsonSchemaPropertyName === m.jsonSchemaPropertyName) || { tags: [] } ).tags}
						allowNewTags={false}
						onChange={(newValue) => {
							const tags = (newValue as TaxonomyTagSummary[]).map(m => m.id);
							const taxonomy = props.model.taxonomies.find(t => t.jsonSchemaPropertyName === m.jsonSchemaPropertyName);
							taxonomy.tags = tags;
						}}
						mode="edit"
						setBusy={props.setBusy}
					/>
				</Col>
			))
		}
	</Row>
);



// WEBPACK FOOTER //
// ./src/app/bookings/search/requests/search-taxonomy.tsx